export default __webpack_public_path__ + "static/media/infra.c159c6de.png";